function Header(prop) {
  return <h1 className="font-sans font-bold mb-6 text-3xl">{prop.text}</h1>;
}

export default Header;
